import cucumberUrl from '../../arts/player-game/cucumber.webp';
import tomatoUrl from '../../arts/player-game/tomato.webp';
import carrotUrl from '../../arts/player-game/carrot.webp';
import onionUrl from '../../arts/player-game/onion.webp';
import beetrootUrl from '../../arts/player-game/beetroot.webp';
import chiliUrl from '../../arts/player-game/chili.webp';
import potatoUrl from '../../arts/player-game/potato.webp';
import eggplantUrl from '../../arts/player-game/eggplant.webp';
import cornbobUrl from '../../arts/player-game/cornbob.webp';
import celeryUrl from '../../arts/player-game/celery.webp';
import { PLAYER_SKINS, type PlayerSkin } from 'shared';

export { cucumberUrl };

export const skinUrlsById: Record<PlayerSkin, string> = {
  cucumber: cucumberUrl,
  tomato: tomatoUrl,
  carrot: carrotUrl,
  onion: onionUrl,
  beetroot: beetrootUrl,
  chili: chiliUrl,
  potato: potatoUrl,
  eggplant: eggplantUrl,
  cornbob: cornbobUrl,
  celery: celeryUrl,
};

export const skinUrls = PLAYER_SKINS.map(skin => skinUrlsById[skin]);
